/** DOM id of the page container, used as the portal target for popovers/pickers. */
export const RENTER_PROFILE_ROOT_ID = 'renter-profile-root';
